/**
*
* Product detail tabs
*
*/
let $tabs = $('[data-tabs]')
$.each($tabs, function(index, item) {

    // Give the tab list a unique id
    let parentId = Math.random().toString(36).substr(2, 9)
    $(item).attr('data-tabs', parentId)

    // & give the tabs content a unique too
    let $content = $(item).closest('.product-tabs-container').find('[data-tabs-content]')
    $content.attr('data-tabs-content', parentId)

    // Get each tab
    let $tab = $(item).find('.product-tabs-item-link')

    // Loop through and give each tab a unique id
    $.each($tab, function(index, item) {

        // Give the tabs/content a unique id
        let itemId = Math.random().toString(36).substr(2, 9)

        // Give each tab
        $(item).attr('data-tab-item', itemId)

        // Find the content tab
        let $contentItem = $content.find('.product-tabs-content-item').eq(index)
        $($contentItem).attr('data-tab-content-item', itemId)

        // Create a click handler
        $(item).on('click', function(e){

            e.preventDefault()

            // Get the tab
            let $tab = $(this)
            let itemId = $(this).data('tab-item')
            let $content = $('[data-tab-content-item="'+itemId+'"]')

            // Sanity check for dev
            if ($content.length == 0) {
                console.warn('The tab content does not exist.')
            }

            // Close all other tabs
            $('.product-tabs-item-link').parent().removeClass('is-active')
            $('[data-tab-content-item]').addClass('hidden')

            // Assign the active state to tab
            $tab.parent().addClass('is-active')

            // Show the tab
            $content.removeClass('hidden')

        })

    })

})
